import { httpClient, mountUrl } from '@/httpClient'

const BASE_URL = '/api/v1/sites/$id/editor'

export const create = ({ id }) => httpClient.post(mountUrl(BASE_URL, { id }))
